export function parsePriceDecimalPlaces(price, pos) {
  const round = 10 ** (pos || 0)
  return Math.round(price * round) / round
}
